/**
 * Ajax filtering for the Insights landing page
 */
(function (window, document, $, undefined) {
  "use strict";

  // variables
  window.chip = "none";
  window.asset = "none";
  window.theme = "none";
  window.format = "none";
  window.region = "none";
  window.lifeBusiness = "none";
  window.trust = "none";
  window.firstLoad = "true";
  window.url = new URL(window.location.origin + window.location.pathname);
  window.selectedQuery = {};
  window.params = window.location.search;
  window.select_ids = {};

  window.filterInsights = {
    init: function () {
      var chip = sessionStorage.getItem("chip");
      if (chip) {
        window.selectedQuery = chip;
        sessionStorage.removeItem("chip");
      }
      var jsonDataLocation = JSON.stringify(window.url.href);
      if (jsonDataLocation.indexOf("insights") >= 0) {
        if (jsonDataLocation.indexOf("market-insights") === -1) {


          var refreshSn = function ()
          {
            var time = 270000; // 4:30
            setTimeout(
              function ()
                {
                  $.ajax({
                    type: "GET",
                    url: localized.ajax_url,
                    dataType: "text",
                    data: {
                      action: "refresh_session",
                  },
                  success: function (response) {
                    refreshSn();
                  },
                  error: function(e) {
                    console.log('error');
                    console.log(e);
                  }

                  });
                },time
            );
          };
          refreshSn();


          var session_reload = sessionStorage.getItem("reload");
          // reload fix url
          /* S */
        }
      }
      // first load rebuild query
      if (window.firstLoad === "true") {
        if (window.location.search !== "") {
          var string = window.location.search
            .substring(1)
            .replace(new RegExp("=", "g"), ",")
            .replace(new RegExp("&", "g"), ",")
            .split(",");
          var chipparam = $.inArray("chip", string);
          if (chipparam !== -1) {
            var num = ++chipparam;
            $(".button_pills__item").removeClass("active");
            $(".button_pills__item[data-slug='" + string[num] + "']").addClass(
              "active"
            );
            Object.assign(window.selectedQuery, {
              chip_tax_term: string[num],
              chip_tax_tax: "jh_chip_categories",
            });
            window.chip = string[num];
          }
          var assetparam = $.inArray("asset", string);
          if (assetparam !== -1) {
            var num = ++assetparam;
            $(
              "#filter_new_asset_class option[value='" + string[num] + "']"
            ).attr("selected", "selected");
            Object.assign(window.selectedQuery, {
              asset_tax_term: string[num],
              asset_tax_tax: "jh_asset_class",
            });
            window.asset = string[num];
            window.url.searchParams.append("asset", string[num]);
          }
          var themeparam = $.inArray("theme", string);
          if (themeparam !== -1) {
            var num = ++themeparam;
            $("#filter_tags option[value='" + string[num] + "']").attr(
              "selected",
              "selected"
            );
            Object.assign(window.selectedQuery, {
              tag_tax_term: string[num],
              tag_tax_tax: "tag_tax_term",
            });
            window.theme = string[num];
            window.url.searchParams.append("theme", string[num]);
          }
          var formatparam = $.inArray("format", string);
          if (formatparam !== -1) {
            var num = ++formatparam;
            $("#filter_new_format option[value='" + string[num] + "']").attr(
              "selected",
              "selected"
            );
            Object.assign(window.selectedQuery, {
              format_tax_term: string[num],
              format_tax_tax: "jh_article_format",
            });
            window.format = string[num];
            window.url.searchParams.append("format", string[num]);
          }
          var regionparam = $.inArray("region", string);
          if (regionparam !== -1) {
            var num = ++regionparam;
            $("#filter_new_region option[value='" + string[num] + "']").attr(
              "selected",
              "selected"
            );
            Object.assign(window.selectedQuery, {
              region_tax_term: string[num],
              region_tax_tax: "article_region",
            });
            window.region = string[num];
            window.url.searchParams.append("region", string[num]);
          }
          var lifeparam = $.inArray("lifeBusiness", string);
          if (lifeparam !== -1) {
            var num = ++lifeparam;
            $("#filter_life_business option[value='" + string[num] + "']").attr(
              "selected",
              "selected"
            );
            Object.assign(window.selectedQuery, {
              life_tax_term: string[num],
              life_tax_tax: "jh_life_business",
            });
            window.lifeBusiness = string[num];
            window.url.searchParams.append("lifeBusiness", string[num]);
          }
          var trustparam = $.inArray("trust", string);
          if (trustparam !== -1) {
            var num = ++trustparam;
            $("#filter_trusts option[value='" + string[num] + "']").attr(
              "selected",
              "selected"
            );
            Object.assign(window.selectedQuery, {
              trust_tax_term: string[num],
              trust_tax_tax: "article_trusts",
            });
            window.trust = string[num];
            window.url.searchParams.append("trust", string[num]);
          }
        } else {
        }
      }
      // filter selects for deep linking
      if (window.location.search !== "") {
        var string = window.location.search
          .substring(1)
          .replace(new RegExp("=", "g"), ",")
          .replace(new RegExp("&", "g"), ",")
          .split(",");
        var chipparam = $.inArray("chip", string);
        if (chipparam !== -1) {
          var num = ++chipparam;
          $(".button_pills__item").removeClass("active");
          $(".button_pills__item[data-slug='" + string[num] + "']").addClass(
            "active"
          );
        }
        var assetparam = $.inArray("asset", string);
        if (assetparam !== -1) {
          var num = ++assetparam;
          $("#filter_new_asset_class option[value='" + string[num] + "']").attr(
            "selected",
            "selected"
          );
          $("#filter_new_asset_class").prop("disabled", true);
          $("#filter_new_asset_class").css("cursor", "not-allowed");
        }
        var themeparam = $.inArray("theme", string);
        if (themeparam !== -1) {
          var num = ++themeparam;
          $("#filter_tags option[value='" + string[num] + "']").attr(
            "selected",
            "selected"
          );
          $("#filter_tags").prop("disabled", true);
          $("#filter_tags").css("cursor", "not-allowed");
        }
        var regionparam = $.inArray("region", string);
        if (regionparam !== -1) {
          var num = ++regionparam;
          $("#filter_new_region option[value='" + string[num] + "']").attr(
            "selected",
            "selected"
          );
          $("#filter_new_region").prop("disabled", true);
          $("#filter_new_region").css("cursor", "not-allowed");
        }
        var lifeparam = $.inArray("lifeBusiness", string);
        if (lifeparam !== -1) {
          var num = ++lifeparam;
          $("#filter_life_business option[value='" + string[num] + "']").attr(
            "selected",
            "selected"
          );
          $("#filter_life_business").prop("disabled", true);
          $("#filter_life_business").css("cursor", "not-allowed");
        }
        var formatparam = $.inArray("format", string);
        if (formatparam !== -1) {
          var num = ++formatparam;
          $("#filter_new_format option[value='" + string[num] + "']").attr(
            "selected",
            "selected"
          );
          $("#filter_new_format").prop("disabled", true);
          $("#filter_new_format").css("cursor", "not-allowed");
        }
        var trustparam = $.inArray("trust", string);
        if (trustparam !== -1) {
          var num = ++trustparam;
          $("#filter_trusts option[value='" + string[num] + "']").attr(
            "selected",
            "selected"
          );
          $("#filter_trusts").prop("disabled", true);
          $("#filter_trusts").css({
            cursor: "not-allowed",
            "text-overflow": "ellipsis",
            "padding-right": "3em",
          });
        }
      }

      // init required functions
      filterInsights.chipHandling();
      filterInsights.selectHandling();
      filterInsights.clearFiltersButton();
    },

    chipHandling: function () {
      $(".button_pills__item.all").on("click", function (ev) {
        ev.preventDefault();
        filterInsights.clearOptions();
        filterInsights.disableButtons();
        $(".button_pills__item").removeClass("active");
        $(this).addClass("active");
        window.firstLoad = "false";
        window.chip = "none";
        window.history.replaceState(
          {},
          "",
          window.url.origin + window.url.pathname
        );
        filterInsights.ajaxPosts();
      });
      $(".button_pills__item.select").on("click", function (ev) {
        ev.preventDefault();
        $(".button_pills__item").removeClass("active");
        $(this).addClass("active");
        filterInsights.disableButtons();
        filterInsights.clearOptions();
        window.firstLoad = "false";
        window.chip = $(this).attr("value");
        Object.assign(window.selectedQuery, {
          chip_tax_term: $(this).attr("value"),
          chip_tax_tax: $(this).attr("data-tax"),
        });
        var chipURL = new URL(
          window.url.origin +
            window.url.pathname +
            "?chip=" +
            $(this).attr("value")
        );
        window.history.replaceState({}, "", chipURL);
        filterInsights.ajaxPosts();
      });
    },

    selectHandling: function () {
      // grab ids of the selects
      $(".insight_sub_filter").each(function () {
        window.select_ids[this.id] = this[1].dataset.argType;
      });
      // loop through the ids
      $.each(window.select_ids, function (key, val) {
        var item = "#" + key;
        $(item).change(function () {
          $(this).attr("selected", "selected");
          filterInsights.disableButtons();
          window.firstLoad = "false";
          var chosen = $(item + " option:selected");
          var window_var = chosen.attr("value");
          if (window.url.searchParams.has(chosen.attr("data-arg-type"))) {
            window.url.searchParams.delete(chosen.attr("data-arg-type"));
          }
          window.url.searchParams.append(
            chosen.attr("data-arg-type"),
            chosen.attr("value")
          );
          var option = window.url["search"]
            .substring(1)
            .replace(new RegExp("=", "g"), ",")
            .replace(new RegExp("&", "g"), ",")
            .split(",");
          var assetparam = $.inArray("asset", option);
          if (assetparam !== -1) {
            if (window.asset === "none") {
              window.asset = window_var;
              Object.assign(window.selectedQuery, {
                asset_tax_term: window_var,
                asset_tax_tax: chosen.attr("data-tax-type"),
              });
            }
          }
          var themeparam = $.inArray("theme", option);
          if (themeparam !== -1) {
            if (window.theme === "none") {
              window.theme = window_var;
              Object.assign(window.selectedQuery, {
                tag_tax_term: window_var,
                tag_tax_tax: chosen.attr("data-tax-type"),
              });
            }
          }
          var formatparam = $.inArray("format", option);
          if (formatparam !== -1) {
            if (window.format === "none") {
              window.format = window_var;
              Object.assign(window.selectedQuery, {
                format_tax_term: window_var,
                format_tax_tax: "jh_article_format",
              });
            }
          }
          var regionparam = $.inArray("region", option);
          if (regionparam !== -1) {
            if (window.region === "none") {
              window.region = window_var;
              Object.assign(window.selectedQuery, {
                region_tax_term: window_var,
                region_tax_tax: "article_region",
              });
            }
          }
          var lifeparam = $.inArray("lifeBusiness", option);
          if (lifeparam !== -1) {
            if (window.lifeBusiness === "none") {
              window.lifeBusiness = window_var;
              Object.assign(window.selectedQuery, {
                life_tax_term: window_var,
                life_tax_tax: "jh_life_business",
              });
            }
          }
          var trustparam = $.inArray("trust", option);
          if (trustparam !== -1) {
            if (window.trust === "none") {
              window.trust = window_var;
              Object.assign(window.selectedQuery, {
                trust_tax_term: window_var,
                trust_tax_tax: chosen.attr("data-tax-type"),
              });
            }
          }
          if (window.chip !== "none") {
            var newParam = window.url["search"].substring(1);
            var add_param_url =
              window.location.origin +
              window.location.pathname +
              "?chip=" +
              window.chip +
              "&" +
              newParam;
            window.history.pushState({}, "", add_param_url);
            // }
          } else {
            var sub_filter_url =
              window.location.origin +
              window.location.pathname +
              window.url.search;
            window.history.pushState({}, "", sub_filter_url);
          }
          filterInsights.ajaxPosts();
        });
      });
    },

    ajaxPosts: function () {
      var size = Object.keys(window.selectedQuery).length;
      if (size === 0) {
        Object.assign(window.selectedQuery, {
          empty: "empty",
        });
      } else {
        if (window.selectedQuery.empty) {
          delete window.selectedQuery.empty;
        }
      }
      $.ajax({
        type: "GET",
        url: localized.ajax_url,
        dataType: "html",
        data: {
          action: "get_insights",
          query: window.selectedQuery,
          origin: window.location.pathname,
        },
        cache: false,
        beforeSend: function () {
          // setting skeleton loading structure
          $("#insights_posts").empty();
          $("#insights_posts").html(JH_insights_filter_skeleton_loading());
        },
        complete: function (response) {
          //removing skeleton loading structure
          $("#insights_posts .skeleton_row").remove();
          //////////////////////////////////////////////
          var jsonData = JSON.stringify(response.responseText);
          if (jsonData.indexOf("Nothing Found") >= 0) {
            filterInsights.ajaxPostsResults();
          } else {
            document.getElementById("ajax-archive").innerHTML =
              response.responseText;
            filterInsights.loadMoreCheck();
            filterInsights.init();
            $("select").on("click", function () {
              if ($("select").hasClass("select-dropdown-opened")) {
                $("select").removeClass("select-dropdown-opened");
              } else {
                $(this).addClass("select-dropdown-opened");
                $(this).removeClass("select-dropdown-closed");
              }
            });

            $("select").on("focusout", function () {
              $(this).removeClass("select-dropdown-opened");
              $(this).addClass("select-dropdown-closed");
            });
          }

          // Run Hovering effects
          var window_width = $(window).width();
          if (window_width < 768) {
            setTimeout(function () {
              insights_box_height_mobile();
            }, 1000);
          } else {
            setTimeout(function () {
              insights_equal_boxes();
              //big isights insert image for desktop
              $(".articles-special-row .wrap-article-big-left .insights_image")
                  .insertAfter(".articles-special-row .wrap-article-big-left .big_insights_thumb");
            }, 1000);
          }
          var window_width = $(window).width();
          if (window_width > 991) {
            insights_hover_effect();
          }
        },
      });
    },

    ajaxPostsResults: function () {
      sessionStorage.setItem("reload", "no");
      window.location.reload();
    },

    disableButtons: function () {
      $(".button_pills__item").prop("disabled", true);
      $(".button_pills__item").css("cursor", "wait");
      $(".insight_sub_filter").prop("disabled", true);
      $(".insight_sub_filter").css("cursor", "wait");
      $(".insight_clear").css("cursor", "wait");
    },

    clearOptions: function () {
      window.asset = "none";
      window.theme = "none";
      window.format = "none";
      window.region = "none";
      window.lifeBusiness = "none";
      window.trust = "none";
      window.selectedQuery = {};
      $("#filter_new_asset_class option[value='default']").attr(
        "selected",
        "selected"
      );
      $("#filter_tags option[value='default']").attr("selected", "selected");
      $("#filter_new_format option[value='default']").attr(
        "selected",
        "selected"
      );
      $("#filter_new_region option[value='default']").attr(
        "selected",
        "selected"
      );
      $("#filter_life_business option[value='default']").attr(
        "selected",
        "selected"
      );
      $("#filter_trusts option[value='default']").attr("selected", "selected");
      window.url.searchParams.delete("asset");
      window.url.searchParams.delete("theme");
      window.url.searchParams.delete("format");
      window.url.searchParams.delete("region");
      window.url.searchParams.delete("lifeBusiness");
      window.url.searchParams.delete("trust");
    },

    clearFiltersButton: function () {
      $(".insight_clear#filter-reset").click(function () {
        window.firstLoad = "false";
        filterInsights.disableButtons();
        filterInsights.clearOptions();
        if (window.chip !== "none") {
          var chipURL = new URL(
            window.url.origin + window.url.pathname + "?chip=" + window.chip
          );
          Object.assign(window.selectedQuery, {
            chip_tax_term: window.chip,
            chip_tax_tax: "jh_chip_categories",
          });
          window.history.replaceState({}, "", chipURL);
          filterInsights.ajaxPosts();
        } else {
          window.history.replaceState(
            {},
            "",
            window.url.origin + window.url.pathname
          );
          filterInsights.ajaxPosts();
        }
      });
    },

    loadMoreCheck: function () {
      var loadMore = document.getElementById("hidden_load_more").innerText;
      if (loadMore < 1) {
        $("#jh_load_more_insights").css("display", "none");
      }
    },
  };

  filterInsights.init();

  //////////////////////////////////////////////////////
  //// Insights Custom Hovering Effects ////////////////
  //////////////////////////////////////////////////////

  var window_width = $(window).width();
  if (window_width > 991) {
      insights_hover_effect();
  }
  function insights_hover_effect() {
      // Normal Card Hover Effect
      $(".jh-articles-row-custom.ordering_div .article-preview").mouseenter(function () {
          var excerptHeight = $(this).find(".hover_excerpt").innerHeight(); // Excerpt

          $(this).find(".preview-text").css({
            top: -excerptHeight
          });
      }).mouseleave(function () { // Mouse leave (remove hover)
          $(this).find(".preview-text").css({
            top: 0
          });
      });

      // Get Large Card Height
      var largeCardExcerpt = $(".articles-special-row .wrap-article-big-left .article-preview .hover_excerpt").innerHeight(); // Excerpt
      //Set large card max-height to 0
      $(".articles-special-row .wrap-article-big-left .article-preview .hover_excerpt").css('max-height', 0);

      // Large Card Hover Effect
      $(".articles-special-row .wrap-article-big-left .article-preview").mouseenter(function () {
          //var excerptHeight = $(this).find(".hover_excerpt").innerHeight(); // Excerpt

          $(this).find(".hover_excerpt").css("max-height", largeCardExcerpt);
      }).mouseleave(function () { // Mouse leave (remove hover)
          $(this).find(".hover_excerpt").css("max-height", 0);
      });
  }

  ///////////////////////////////////////////////////////
  ////// Insights Equal Heights Boxes //////////////////
  //////////////////////////////////////////////////////

  //start equal height insights boxes
  function insights_equal_boxes() {
    // Select and loop the container element of the elements you want to equalise
    $(".jh-articles-row-custom.ordering_div").each(function () {
      // Cache the tallest and Large promo
      var tallestBox = 0;

      // Select and loop the elements you want to equalise
      $(".article-preview", this).each(function () {
        var excerptHeight = $(this).find(".hover_excerpt").innerHeight();
        var linkHeight = $(this).find(".controls").innerHeight();
        var bodyHeight = $(this).find(".preview-text").innerHeight();
        var imageHeight = $(this).find(".insights_image").innerHeight();
        var combinedHeight = bodyHeight + imageHeight + linkHeight - excerptHeight;

        // If this box is taller than the tallest cached box then store it
        if ( combinedHeight > tallestBox ) {
          tallestBox = combinedHeight;
        }
      });

      // Set the height of all those children to whichever was highest
      $(".article-preview", this).height( tallestBox );
    });
  }

  //start Tablet equal height insights boxes
  function tablet_insights_equal_boxes() {
    // Select and loop the container element of the elements you want to equalise
    $(".jh-articles-row-custom.ordering_div").each(function () {
      // Cache the tallest and Large promo
      var tallestBox = 0;

      // Select and loop the elements you want to equalise
      $(".article-preview", this).each(function () {
        var excerptHeight = $(this).find(".hover_excerpt").innerHeight();
        var linkHeight = $(this).find(".controls").innerHeight();
        var bodyHeight = $(this).find(".preview-text").innerHeight();
        var imageHeight = $(this).find(".insights_image").innerHeight();
        var combinedHeight = bodyHeight + imageHeight + linkHeight;

        // If this box is taller than the tallest cached box then store it
        if ( combinedHeight > tallestBox ) {
          tallestBox = combinedHeight;
        }
      });

      // Set the height of all those children to whichever was highest
      $(".article-preview", this).height( tallestBox );
    });
  }

  $(window).on("load resize", function () {
    var window_width = $(window).width();
    if ( window_width >= 991 ) {
      insights_equal_boxes();
    } else if ( window_width >= 768 ) {
      tablet_insights_equal_boxes();
    }
  });

  //////////////////////////////////////////////
  //// Insights Skeleton Loading ///////////////
  //////////////////////////////////////////////

  // JH_insights_filter_skeleton_loading() to load the full structure on filter

  // JH_insights_load_more_skeleton_loading($num_of_rows, $num_of_cols) to load the full structure on LoadMore
  // JH_insights_load_more_skeleton_loading() default will load 2 row and 3 cols in every row.

  function JH_insights_skeleton_normal_article() {
    var $html = '<article class="skeleton_article">';
    $html += '<div class="skeleton_thumb">';
    $html += '<span class="skeleton_img skeleton-loader"></span>';
    $html += "</div>";
    $html += '<div class="skeleton_date_tag">';
    $html += '<span class="skeleton_date skeleton-loader"></span>';
    $html += '<span class="skeleton_tag skeleton-loader"></span>';
    $html += '<div class="clearfix"></div>';
    $html += "</div>";
    $html += "<hr>";
    $html += '<div class="skeleton_content">';
    $html += '<span class="skeleton_fullwidth skeleton-loader"></span>';
    $html += '<span class="skeleton_fullwidth skeleton-loader"></span>';
    $html += '<span class="skeleton_half skeleton-loader"></span>';
    $html += '<span class="skeleton_tags skeleton-loader"></span>';
    $html += '<span class="skeleton_watch_btn skeleton-loader"></span>';
    $html += "</div>";
    $html += "</article>";
    return $html;
  }

  function JH_insights_skeleton_big_left_article() {
    var $html = '<div class="skeleton_left">';
    $html += '<article class="skeleton_article skeleton-loader">';
    $html += '<span class="skeleton_img skeleton-loader"></span>';
    $html += '<div class="skeleton_content">';
    $html += '<div class="skeleton_date_tag">';
    $html += '<span class="skeleton_date skeleton-loader"></span>';
    $html += '<span class="skeleton_tag skeleton-loader"></span>';
    $html += '<div class="clearfix"></div>';
    $html += "</div>";
    $html += "<hr>";
    $html += '<span class="skeleton_fullwidth skeleton-loader"></span>';
    $html += '<span class="skeleton_fullwidth skeleton-loader"></span>';
    $html += '<span class="skeleton_half skeleton-loader"></span>';
    $html += '<span class="skeleton_tags skeleton-loader"></span>';
    $html += '<span class="skeleton_watch_btn skeleton-loader"></span>';
    $html += "</div>";
    $html += "</article>";
    $html += "</div>";
    return $html;
  }

  function JH_insights_skeleton_small_right_article() {
    var $html = '<article class="skeleton_article">';
    $html += '<div class="skeleton_small_article_content">';
    $html += '<div class="skeleton_date_tag">';
    $html += '<span class="skeleton_date skeleton-loader"></span>';
    $html += '<span class="skeleton_tag skeleton-loader"></span>';
    $html += '<div class="clearfix"></div>';
    $html += "</div>";
    $html += '<div class="skeleton_content">';
    $html += '<span class="skeleton_fullwidth skeleton-loader"></span>';
    $html += '<span class="skeleton_fullwidth skeleton-loader"></span>';
    $html += '<span class="skeleton_half skeleton-loader"></span>';
    $html += "</div>";
    $html += "</div>";
    $html += '<div class="skeleton_thumb">';
    $html += '<span class="skeleton_img skeleton-loader"></span>';
    $html += "</div>";
    $html += '<div class="clearfix"></div>';
    $html += "</article>";
    return $html;
  }

  function JH_insights_skeleton_normal_row($num_of_normal_articles) {
    var $html = '<div class="row_wrap">';
    for (var i = 0; i < $num_of_normal_articles; i++) {
      $html += JH_insights_skeleton_normal_article();
    }
    $html += "</div>";
    return $html;
  }

  function JH_insights_skeleton_special_row($num_of_small_articles) {
    var $html = '<div class="special_row">';
    $html += JH_insights_skeleton_big_left_article();
    $html += '<div class="skeleton_right">';
    for (var i = 0; i < $num_of_small_articles; i++) {
      $html += JH_insights_skeleton_small_right_article();
    }
    $html += "</div>";
    $html += '<div class="clearfix"></div>';
    $html += "</div>";
    return $html;
  }

  function JH_insights_filter_skeleton_loading() {
    var $num_of_normal_articles = 3;
    var $num_of_small_articles = 4;
    var $html = '<section class="skeleton_row">';
    $html += JH_insights_skeleton_normal_row($num_of_normal_articles);
    $html += JH_insights_skeleton_special_row($num_of_small_articles);
    $html += JH_insights_skeleton_normal_row($num_of_normal_articles);
    $html += "</section>";
    return $html;
  }

  function JH_insights_load_more_skeleton_loading() {
    var $num_of_rows = 2;
    var $num_of_article_in_row = 3;
    var $html = '<section class="skeleton_row skeleton_row_loadmore">';
    for (var i = 0; i < $num_of_rows; i++) {
      $html += JH_insights_skeleton_normal_row($num_of_article_in_row);
    }
    $html += "</section>";
    return $html;
  }


  /////////////////////////////////////
  //// Insights Keep Current Page//////
  /////////////////////////////////////



  ///////////////////////////////
  //// Insights Load More ///////
  ///////////////////////////////

  $("#jh_load_more_insights > a").click(function (e) {
    var $lm = $("#jh_load_more_insights");
    e.preventDefault();
    $.ajax({
      type: "GET",
      url: localized.ajax_url,
      dataType: "html",
      data: {
        action: "insights_loadmore",
      },
      cache: false,
      beforeSend: function () {
        // setting skeleton loading structure
        $("#insights_posts").append(JH_insights_load_more_skeleton_loading());
      },
      success: function (response) {
        //removing skeleton loading structure
        $("#insights_posts .skeleton_row").remove();
        //////////////////////////////////////////////
        $("#insights_posts").append(response);
        var lmArray = document.getElementsByClassName("hidden_load_more_ajax");
        var num = lmArray.length - 1;
        var loadMore = lmArray[num].innerText;
        if (loadMore < 1) {
          $("#jh_load_more_insights").css("display", "none");
        }
        // Run Hovering effects
        setTimeout(function () {
          var window_width = $(window).width();
          if (window_width > 991) {
            insights_hover_effect();
          }

          if (window_width < 768) {
            insights_box_height_mobile();
          } else {
            insights_equal_boxes();
          }
        }, 1000);
      },
    });

    return false;
  });
})(window, document, jQuery);
